import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, ArrowLeft, Send, CheckCircle2 } from 'lucide-react';
import { authApi } from '../../utils/api';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await authApi.forgot(email.trim());
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Une erreur est survenue. Réessayez.');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-cream-100 to-cream-200 flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-gold-400 to-gold-600 flex items-center justify-center mx-auto mb-4 shadow-lg">
            <span className="font-serif text-white text-3xl font-semibold">G</span>
          </div>
          <h1 className="font-serif text-2xl text-navy-900">Mot de passe oublié</h1>
          <p className="text-navy-300 text-sm mt-0.5">On vous envoie un lien de réinitialisation</p>
        </div>

        {sent ? (
          <div className="bg-white rounded-[22px] shadow-xl p-6 text-center">
            <CheckCircle2 size={40} className="text-green-500 mx-auto mb-3" />
            <p className="text-[14px] text-navy-700 leading-relaxed">
              Si un compte correspond à cette adresse, un <strong>email de réinitialisation</strong> vient d'être
              envoyé. Pensez à vérifier vos courriers indésirables.
            </p>
            <p className="text-[13px] text-navy-400 mt-2">Le lien est valable 1&nbsp;heure.</p>
            <Link to="/" className="apple-btn-primary w-full justify-center mt-5">Retour à la connexion</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="bg-white rounded-[22px] shadow-xl p-6 space-y-4">
            <p className="text-[13px] text-navy-500 leading-relaxed">
              Saisissez l'adresse email associée à votre compte. Vous recevrez un lien pour choisir un nouveau
              mot de passe.
            </p>
            <div>
              <label className="block text-[13px] font-medium text-navy-600 mb-1.5">Adresse email</label>
              <div className="relative">
                <Mail size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-navy-300" />
                <input
                  autoFocus
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  className="w-full pl-9 pr-3 py-2.5 border border-cream-300 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-navy-300 focus:border-transparent"
                  placeholder="vous@exemple.fr"
                />
              </div>
            </div>

            {error && <div className="text-[13px] text-red-600 bg-red-50 rounded-lg px-3 py-2">{error}</div>}

            <button
              type="submit"
              disabled={loading || !email}
              className="w-full bg-navy-800 hover:bg-navy-700 text-white py-2.5 rounded-xl font-medium flex items-center justify-center gap-2 transition-colors disabled:opacity-50"
            >
              <Send size={16} /> {loading ? 'Envoi…' : 'Envoyer le lien'}
            </button>
          </form>
        )}

        <div className="flex items-center justify-center mt-6">
          <Link to="/" className="inline-flex items-center gap-1.5 text-[13px] text-navy-400 hover:text-navy-700">
            <ArrowLeft size={15} /> Retour à la connexion
          </Link>
        </div>
      </div>
    </div>
  );
}
